import { render, staticRenderFns } from "./franchisee-detail.vue?vue&type=template&id=7b2f53a8&scoped=true"
import script from "./franchisee-detail.vue?vue&type=script&lang=js"
export * from "./franchisee-detail.vue?vue&type=script&lang=js"
import style0 from "./franchisee-detail.vue?vue&type=style&index=0&id=7b2f53a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2f53a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b2f53a8')) {
      api.createRecord('7b2f53a8', component.options)
    } else {
      api.reload('7b2f53a8', component.options)
    }
    module.hot.accept("./franchisee-detail.vue?vue&type=template&id=7b2f53a8&scoped=true", function () {
      api.rerender('7b2f53a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/operation-manage/franchisee-detail.vue"
export default component.exports